import { PermissionsActionType, PERMISSION_PROP } from './constants'

export const initialCreateState = {
    [PERMISSION_PROP.NAME]: '',
}

export const getDefaultState = () => ({
    editPermissionDialog: initialCreateState,
    createPermissionDialog: initialCreateState,
    table: {
        orderBy: {
            col: PERMISSION_PROP.NAME,
            order: 'asc',
        },
        search: '',
        limit: 10,
        offset: 0,
        filters: [],
    },
    isEditDialogOpen: false,
    isCreateDialogOpen: false,
    isConfirmationDialogOpen: false,
    permissions: [],
    total: 0,
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case PermissionsActionType.SET_PERMISSIONS:
            return setPermissionsData(state, action)

        case PermissionsActionType.SET_CREATE_PERMISSION:
            return setCreatePermissionDialog(state, action)
        case PermissionsActionType.OPEN_CREATE_DIALOG:
            return openCreateDialog(state, action)
        case PermissionsActionType.CLOSE_CREATE_DIALOG:
            return closeCreateDialog(state, action)

        case PermissionsActionType.SET_EDIT_PERMISSION:
            return setEditPermission(state, action)
        case PermissionsActionType.OPEN_EDIT_DIALOG:
            return openEditDialog(state, action)
        case PermissionsActionType.CLOSE_EDIT_DIALOG:
            return closeEditDialog(state, action)

        case PermissionsActionType.SET_ORDER_BY:
            return setOrderBy(state, action)
        case PermissionsActionType.SET_PAGING_OPT:
            return setPagingOptions(state, action)
        case PermissionsActionType.SET_PAGE_OFFSET:
            return setPageOffset(state, action)
        case PermissionsActionType.SET_FILTER:
            return setFilter(state, action)
        case PermissionsActionType.SET_SEARCH_TEXT:
            return setSearchText(state, action)

        case PermissionsActionType.SET_CONFIRMATION_DIALOG:
            return SetCreateConfirmationDialog(state, action)
        default:
            return state
    }
}

const setEditPermission = (state, { data }) => {
    return {
        ...state,
        editPermissionDialog: data,
    }
}

const setPermissionsData = (state, { permissions }) => {
    return {
        ...state,
        permissions: permissions.rows,
        total: permissions.total,
    }
}

const closeEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: false,
        editPermissionDialog: initialCreateState,
    }
}

const openEditDialog = (state) => {
    return {
        ...state,
        isEditDialogOpen: true,
    }
}

const closeCreateDialog = (state) => {
    return {
        ...state,
        isCreateDialogOpen: false,
        createPermissionDialog: initialCreateState,
    }
}

const openCreateDialog = (state) => {
    return {
        ...state,
        isCreateDialogOpen: true,
    }
}

function setCreatePermissionDialog(state, action) {
    return {
        ...state,
        createPermissionDialog: action.createPermissionDialog,
    }
}

function SetCreateConfirmationDialog(state, action) {
    return {
        ...state,
        isConfirmationDialogOpen: action.isOpen,
    }
}

function setSearchText(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            search: action.search,
        },
    }
}

function setFilter(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            filters: action.filters,
        },
    }
}

function setPageOffset(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            offset: action.offset,
        },
    }
}

function setPagingOptions(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            limit: action.paging.limit,
            offset: action.paging.offset,
        },
    }
}

function setOrderBy(state, action) {
    return {
        ...state,
        table: {
            ...state.table,
            orderBy: action.orderBy,
        },
    }
}
